import React from 'react';
import { Layout } from '~common/Layout';
import { PageLayout } from '~common/PageLayout';
import { TVLInfo } from '~features/staking/components/TVL';
import { StakingPage } from '~features/staking/StakingPage';

export default function Staking() {
  return (
    <Layout navbarVisibility={{ staking: false }}>
      <PageLayout
        title="Farming pools"
        links={[
          {
            name: 'Deprecated staking pools',
            href: '/staking-legacy',
          },
        ]}
        titleExtra={false && <TVLInfo />}>
        <StakingPage />
      </PageLayout>
    </Layout>
  );
}
